import { render, staticRenderFns } from "./settings-profile-password.vue?vue&type=template&id=32e839e1&"
import script from "./settings-profile-password.ts?vue&type=script&lang=ts&"
export * from "./settings-profile-password.ts?vue&type=script&lang=ts&"
import style0 from "./settings-profile-password.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports